import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { BusinessProfile } from "../types/trainer";

export const businessProfileService = {
  async getForTenant(tenantId: string): Promise<BusinessProfile> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("ensure_tenant_settings", {
      p_tenant_id: tenantId,
    });

    if (error) throw error;
    return data as BusinessProfile;
  },

  async update(
    tenantId: string,
    input: Partial<
      Pick<
        BusinessProfile,
        | "business_name"
        | "public_display_name"
        | "contact_email"
        | "contact_phone"
        | "website_url"
        | "logo_url"
        | "brand_colour"
        | "timezone"
        | "default_check_in_day"
        | "default_client_invite_message"
      >
    >,
  ) {
    assertSupabaseConfigured();

    const { error } = await supabase
      .from("tenant_settings")
      .update(input)
      .eq("tenant_id", tenantId);

    if (error) throw error;
  },
};
